import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgLogoLc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 160 160",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M119.5 89.7c-.8 10.1-9.4 17.3-19 17.3H90l-20 13v-13l20-13h10.5c3.4 0 5.8-2.4 6.1-5.3.6-8.6.5-21.4-.1-30-.2-2.7-2.4-4.9-5.2-5.1-6.9-.3-14.1-.6-21.3-.6-7.2 0-14.4.2-21.2.7-2.9.2-5 2.4-5.2 5.1-.7 8.6-.8 21.4-.1 30 .2 2.8 2.7 5.3 6.1 5.3H70v13H59.5c-9.6 0-18.3-7.1-19-17.3-.7-9.2-.6-22.7.2-32s8.2-16.3 17.3-17c7-.5 14.5-.8 22-.8s15 .3 22.1.8c9.1.7 16.5 7.7 17.3 17 .7 9.2.8 22.7.1 31.9z",
		fill: "#ea541e"
	})
});
export default SvgLogoLc;
